import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=cceb0910"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cceb0910')) {
      api.createRecord('cceb0910', component.options)
    } else {
      api.reload('cceb0910', component.options)
    }
    module.hot.accept("./Resource.vue?vue&type=template&id=cceb0910", function () {
      api.rerender('cceb0910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Resource.vue"
export default component.exports